<div [class]="'w-fit-content special-categories-card  '+item().borderClass" (click)="onCategoryClicked()" role="button">
  <div class="d-flex align-items-center gap-3">
    <img [src]="item().specialIcon || 'assets/images/product-placeholder.webp'" class="img-fluid object-fit-cover"
      alt="." />
    <span class="special-categories-card__title">
      {{item().name}}
    </span>
  </div>
</div>
